
export function Cross() {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.2525 20L0 14.6944L5.28 9.36111L6.435 10.5278L3.135 13.8611H20.9825V15.5278H3.135L6.4075 18.8333L5.2525 20ZM16.7475 10.6389L15.5925 9.47222L18.865 6.16667H1.0175V4.5H18.865L15.565 1.16667L16.72 0L22 5.33333L16.7475 10.6389Z" fill="#1A1A1A"/>
    </svg>
      )
}
